
export const createIntlPath = (route: string) => {
  const path =  typeof window !== "undefined" ? window.location.pathname : "";
 

  return `${path.slice(0, 3)}${route}`;
  }